module.exports = __webpack_public_path__ + "img/construction-team-planning-stockcake.881bf04d.png";